'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _spauiUtils = require('@tencent/spaui-utils');

var _info2 = require('./info');

var _info3 = _interopRequireDefault(_info2);

var _compact_props = require('./utils/compact_props');

var _compact_props2 = _interopRequireDefault(_compact_props);

var _star_component = require('./component/star_component');

var _star_component2 = _interopRequireDefault(_star_component);

var _label_component = require('./component/label_component');

var _label_component2 = _interopRequireDefault(_label_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

/**
 * @fileOverview 评分组件
 * @author kirkzheng
 * @time 2018-08-20
 * @module @tencent/spaui-rating
 */

/**
 * @class
 */
var Rating = function (_PureComponent) {
    _inherits(Rating, _PureComponent);

    /**
     * 组件属性说明
     * @property {titleline} 全局属性
     * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
     * @property {titleline} 基本属性
     * @property {number} value=0 评分值
     * @property {func} [onChange] 评分值变更<br />onChange=(event, value)
     * @property {number} [max=5] 最多得分
     * @property {string} [label=''] 文案
     * @property {bool} [readOnly=false] 是否只读
     * @property {bool} [clear=false] 是否可清空
     * @property {bool} [half=false] 是否支持半星
     * @property {ele|func} [StarComponent] 星结构组件<br />&lt;StarComponent type='full|half|empty' value='' /&gt;
     * @property {ele|func} [LabelComponent] 文案结构组件<br />&lt;LabelComponent label='' /&gt;
     */
    function Rating(props) {
        _classCallCheck(this, Rating);

        var _this = _possibleConstructorReturn(this, (Rating.__proto__ || Object.getPrototypeOf(Rating)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleMouseOver = _this.handleMouseOver.bind(_this);
        _this.handleMouseOut = _this.handleMouseOut.bind(_this);

        _this.state = {
            value: props.value || 0
        };
        return _this;
    }

    _createClass(Rating, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.value !== this.props.value) {
                this.setState({
                    value: nextProps.value || 0
                });
            }
        }

        // 移入的话临时展示选中的数据

    }, {
        key: 'handleMouseOver',
        value: function handleMouseOver(event) {
            // 获取html上的属性值
            var getHtmlAttributeValue = function getHtmlAttributeValue() {
                var attributeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                return parseFloat(event.target.getAttribute(attributeName) || '') || 0;
            };

            var _compactProps = (0, _compact_props2.default)(this.props),
                readOnly = _compactProps.readOnly;

            var _compactProps2 = (0, _compact_props2.default)(this.props),
                half = _compactProps2.half;

            var result = 0,
                value = 0,
                halfValue = 0;

            // 有结构非可读就获取对应内容
            if (event.target && !readOnly) {
                value = getHtmlAttributeValue('data-value');
                halfValue = getHtmlAttributeValue('data-halfvalue');

                // 半星的使用data-halfvalue
                // 全星的使用data-value
                if (half) {
                    result = halfValue;
                } else {
                    result = value;
                }

                // 只有大于0的才算有效
                if (result > 0) {
                    this.setState({
                        value: result
                    });
                }
            }
        }

        // 移出的话就还原回来

    }, {
        key: 'handleMouseOut',
        value: function handleMouseOut(event) {
            var _props$value = this.props.value,
                value = _props$value === undefined ? 0 : _props$value;

            var _compactProps3 = (0, _compact_props2.default)(this.props),
                readOnly = _compactProps3.readOnly;

            if (!readOnly) {
                this.setState({
                    value: value
                });
            }
        }

        // 点击的话就正式选中数据

    }, {
        key: 'handleClick',
        value: function handleClick(event) {
            var _props = this.props,
                onChange = _props.onChange,
                propsValue = _props.value;

            var _compactProps4 = (0, _compact_props2.default)(this.props),
                readOnly = _compactProps4.readOnly;

            var _compactProps5 = (0, _compact_props2.default)(this.props),
                clear = _compactProps5.clear;

            var value = this.state.value;

            var result = void 0;

            if (!readOnly && (0, _spauiUtils.isFunction)(onChange)) {
                if (propsValue === value && clear) {
                    result = 0;
                } else if (propsValue !== value) {
                    result = value;
                }

                if (typeof result !== 'undefined') {
                    onChange(event, result);
                }
            }
        }
    }, {
        key: 'getStarsDom',
        value: function getStarsDom() {
            var _props2 = this.props,
                max = _props2.max,
                StarComponent = _props2.StarComponent;
            var value = this.state.value;

            var floatValue = parseFloat(value) || 0;
            var floorValue = Math.floor(floatValue) || 0; // 向下取整
            var halfValue = floatValue - floorValue;
            var result = [],
                tempValue = 0,
                i = 0;

            for (; i < floorValue; i++) {
                tempValue = tempValue + 1;
                result.push(_react2.default.createElement(StarComponent, { type: 'full', value: tempValue, key: tempValue }));
            }
            if (halfValue === 0.5) {
                tempValue = tempValue + 1;
                result.push(_react2.default.createElement(StarComponent, { type: 'half', value: tempValue, key: tempValue }));
            }
            i = result.length;
            for (; i < max; i++) {
                tempValue = tempValue + 1;
                result.push(_react2.default.createElement(StarComponent, { type: 'empty', value: tempValue, key: tempValue }));
            }

            return result;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                LabelComponent = _props3.LabelComponent,
                label = _props3.label,
                title = _props3.title;

            var _compactProps6 = (0, _compact_props2.default)(this.props),
                readOnly = _compactProps6.readOnly;

            return _react2.default.createElement(
                'div',
                _extends({}, (0, _spauiUtils.globalProps)(this.props, {
                    className: (0, _classnames2.default)('spaui-rating', {
                        readonly: readOnly
                    })
                }, Rating), {
                    title: ''
                }),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'spaui-rating-stars',
                        onMouseOver: this.handleMouseOver,
                        onMouseOut: this.handleMouseOut,
                        onClick: this.handleClick,
                        title: title
                    },
                    this.getStarsDom()
                ),
                _react2.default.createElement(LabelComponent, {
                    label: label
                })
            );
        }
    }]);

    return Rating;
}(_react.PureComponent);

// 组件标记与上报


Rating.propTypes = {
    value: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.number, _spauiUtils.PropTypes.string]).isRequired,
    onChange: _spauiUtils.PropTypes.func,
    max: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.number, _spauiUtils.PropTypes.string]),
    label: _spauiUtils.PropTypes.string,
    readOnly: _spauiUtils.PropTypes.bool,
    clear: _spauiUtils.PropTypes.bool,
    half: _spauiUtils.PropTypes.bool,
    StarComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
    LabelComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element])
};
Rating.defaultProps = {
    value: 0,
    max: 5,
    label: '',
    readOnly: false,
    clear: false,
    half: false,
    StarComponent: _star_component2.default,
    LabelComponent: _label_component2.default
};
(0, _spauiUtils.setComponentMark)(Rating, _info3.default, function () {
    (0, _spauiUtils.reportComponentUsage)(_extends({
        scope: 'spaui'
    }, _info3.default));
});

exports.default = Rating;